import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    fileId: {
        name: () => '文件内容',
    },

    text: {
        name: () => '文件名',
        required: () => true,
    },
})
